export { Typography } from "@mui/material";
export type { TypographyProps } from "@mui/material/Typography";
